<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="klaimPresensi && klaimPresensi.klaimPresensi_id ? 'Ubah Presensi' : 'Ubah Presensi'"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row row wrap>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-alert class="body-2" dense text type="info">
                  Silakan inputkan data Presensi yang ingin diubah. Jika ingin dianggap hadir <b>tepat waktu</b>. Maka
                  <b>tidak perlu</b> dipilih skor datang dan skor pulang.
                </v-alert>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <label class="caption mb-2">Pilih Anggota</label>
                <v-autocomplete
                  dense
                  single-line
                  outlined
                  v-model="klaimPresensi.user_id"
                  :items="users"
                  label="Pilih Anggota"
                  persistent-hint
                  item-text="nama"
                  item-value="user_id"
                  data-vv-name="user"
                  data-vv-as="Anggota"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.user')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <label class="caption mb-2">Tanggal Presensi</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  :label="'Tanggal'"
                  v-model="klaimPresensi.wkt_presensi"
                  hint="Tanggal"
                  data-vv-name="tanggal"
                  data-vv-as="Tanggal"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggal')"
                ></m-datepicker>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                <label class="caption mb-2">Skor Datang</label>
                <v-select
                  dense
                  single-line
                  outlined
                  clearable
                  :items="kategoriKetidakhadiran"
                  v-model="klaimPresensi.skor_datang_id"
                  label="Diisi jika akan terlambat datang"
                  item-value="skor_presensi_id"
                  item-text="nama"
                  data-vv-name="skor"
                  data-vv-as="skor"
                  v-validate="''"
                  :error-messages="errors.collect('form.skor')"
                ></v-select>
              </v-col>
              <v-col v-if="[3, 5].includes(Number(kJenisPresensi))" cols="12" sm="12" md="6" class="py-0">
                <label class="caption mb-2">Skor Awal Istirahat</label>
                <v-select
                  dense
                  single-line
                  outlined
                  clearable
                  :items="kategoriKetidakhadiran"
                  v-model="klaimPresensi.skor_istirahat_mulai_id"
                  label="Diisi jika akan pulang cepat"
                  item-value="skor_presensi_id"
                  item-text="nama"
                  data-vv-name="skor"
                  data-vv-as="skor"
                  v-validate="''"
                  :error-messages="errors.collect('form.skor')"
                ></v-select>
              </v-col>
              <v-col v-if="[4, 5].includes(Number(kJenisPresensi))" cols="12" sm="12" md="6" class="py-0">
                <label class="caption mb-2">Skor Akhir Istirahat</label>
                <v-select
                  dense
                  single-line
                  outlined
                  clearable
                  :items="kategoriKetidakhadiran"
                  v-model="klaimPresensi.skor_istirahat_selesai_id"
                  label="Diisi jika akan terlambat datang"
                  item-value="skor_presensi_id"
                  item-text="nama"
                  data-vv-name="skor"
                  data-vv-as="skor"
                  v-validate="''"
                  :error-messages="errors.collect('form.skor')"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                <label class="caption mb-2">Skor Pulang</label>
                <v-select
                  dense
                  single-line
                  outlined
                  clearable
                  :items="kategoriKetidakhadiran"
                  v-model="klaimPresensi.skor_pulang_id"
                  label="Diisi jika akan pulang cepat"
                  item-value="skor_presensi_id"
                  item-text="nama"
                  data-vv-name="skor"
                  data-vv-as="skor"
                  v-validate="''"
                  :error-messages="errors.collect('form.skor')"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <label class="caption mb-2">Keterangan</label>
                <v-textarea
                  dense
                  single-line
                  outlined
                  label="Keterangan"
                  v-model="klaimPresensi.keterangan"
                  hint="Keterangan"
                  data-vv-name="keterangan"
                  data-vv-as="Keterangan"
                  v-validate.persist="'required'"
                  rows="2"
                  :error-messages="errors.collect('form.keterangan')"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      edit: false,
      maxSize: 1,
      users: [],
      file: null,
      errorType: false,
      klaimPresensi: {},
      kategoriKetidakhadiran: [],
      kJenisPresensi: 0,
      defKlaimPresensi: {
        tanggal: null,
        keterangan: null,
      },
    }
  },
  mounted() {},
  methods: {
    // eslint-disable-next-line
    open({ obj = {}, jadwal = {} }) {
      this.getUser()
      if (jadwal && jadwal.k_jenis_presensi) {
        this.kJenisPresensi = jadwal.k_jenis_presensi
      }
      this.reset()
      this.loadKategoriKetidakhadiran().then(() => {
        this.setData(obj)
      })
      this.$validator.reset()
      return this.$refs.dlg.open()
    },
    reset() {
      this.klaimPresensi = {}
    },
    setData(obj) {
      if (obj) {
        const keys = ['skor_datang', 'skor_pulang', 'skor_istirahat_mulai', 'skor_istirahat_selesai']
        Object.keys(obj).forEach((key) => {
          if (keys.includes(key)) {
            if (obj[key]) {
              const items = this.kategoriKetidakhadiran || []
              const find = items.findIndex((s) => s.skor === obj[key]) || -1
              if (find > -1) {
                this.$set(this.klaimPresensi, `${key}_id`, items[find]['skor_presensi_id'])
              }
            }
          } else {
            this.$set(this.klaimPresensi, key, obj[key] || '')
          }
        })
      } else {
        this.klaimPresensi = this.defKlaimPresensi
      }
    },
    loadKategoriKetidakhadiran() {
      return new Promise(resolve => {
        resolve(this.$store
          .dispatch('kategoriTerlambat/get', {
            organisasi_id: this.organisasi_id,
            params: {
              format: 'json',
              page: this.cp,
            },
          })
          .then((res) => {
            this.kategoriKetidakhadiran = res.data
          })
          .catch((e) => e))
      })

    },
    getUser() {
      this.$store.dispatch('user/getUserAktif', { organisasi_id: this.organisasi_id }).then((res) => {
        this.users = [...res.data]
      })
    },
    handleFileUpload() {
      this.errorType = false
      if (this.file) {
        if (this.file.type != 'application/pdf') {
          this.errorType = true
        }
        this.size = (this.file.size / 1000000).toFixed(2)
      }
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          this.$store
            .dispatch('klaimPresensi/form', {
              organisasi_id: this.organisasi_id,
              obj: this.klaimPresensi,
            })
            .then(() => {
              this.$refs.dlg.resolve()
            })
            .catch((e) => e)
        })
        .catch((e) => e)
    },
  },
}
</script>
